var amt_admin = require('amt_admin').default;
var app = require('angular').module('ww2_analytics.paywalls', [amt_admin]);
var { get_paywalls_state_config } = require('./base');
var templates_ctx = require.context('./_templates', false);


function require_template(key) {
  var filename = './' + key + '.html';
  return templates_ctx(filename);
}

function build_state(key, title, is_missions_required) {
  var state_key = 'amt.ww2.paywalls.' + key;
  var state_config = get_paywalls_state_config({
    url: '/' + key,
    title: title,
    template: require_template(key),
    is_missions_required: is_missions_required
  });
  return [state_key, state_config];
}

function configure_states($stateProvider) {
  $stateProvider
    .state('amt.ww2.paywalls', {
      url: '/paywalls',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: 'Paywalls',
        role: 'paywalls',
      },
      menu: {
        glyphicon: 'flag',
        childs: [
          {state: 'amt.ww2.paywalls.logins_after_mission', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.avg_session_count', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.payment_count', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.win_cost', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.power_per_dollar', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.win_rate', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.win_rate_unique', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.payers_count_by_days', glyphicon: 'flag'},
          {state: 'amt.ww2.paywalls.payers_count_by_mission', glyphicon: 'flag'},
        ],
      },
    })
    .state(...build_state('avg_session_count', 'Avg Session Count', true))
    .state(...build_state('win_rate', 'Win Rate', true))
    .state('amt.ww2.paywalls.logins_after_mission', require('./logins_after_mission').default)
    .state('amt.ww2.paywalls.payment_count', require('./payment_count').default)
    .state('amt.ww2.paywalls.power_per_dollar', require('./power_per_dollar').default)
    .state('amt.ww2.paywalls.win_cost', require('./win_cost').default)
    .state('amt.ww2.paywalls.win_rate_unique', require('./win_rate_unique').default)
    .state('amt.ww2.paywalls.payers_count_by_days', require('./payers_count_by_days').default)
    .state('amt.ww2.paywalls.payers_count_by_mission', require('./payers_count_by_mission').default)
}


app.config(['$stateProvider', configure_states]);

app.service('paywalls_api', ['jsonrpc', function (jsonrpc) {
  var service = jsonrpc.newService('paywalls');
  this.win_rate_unique_by_mission_range = service.createMethod('win_rate_unique_by_mission_range');
  this.payment_count_by_mission_range = service.createMethod('payment_count_by_mission_range');
  this.payers_retention_rolling = service.createMethod('payers_retention_rolling');
  this.payers_count_by_mission = service.createMethod('payers_count_by_mission');
}]);

export default app.name;
